module.exports = __webpack_public_path__ + "img/green_137.0fba9ec0.png";